import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const handleBulkRotation = () => {
    console.log('Initiating bulk password rotation...');
  };

  const handleEmergencyAccess = () => {
    console.log('Activating emergency access...');
  };

  const handleComplianceReport = () => {
    console.log('Generating compliance report...');
  };

  const handleSecurityScan = () => {
    console.log('Starting security scan...');
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h2 className="text-lg font-semibold text-foreground mb-4">Quick Actions</h2>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Button
          variant="default"
          onClick={handleBulkRotation}
          iconName="RotateCcw"
          iconPosition="left"
          className="justify-start"
        >
          Bulk Rotation
        </Button>
        
        <Button
          variant="destructive"
          onClick={handleEmergencyAccess}
          iconName="AlertTriangle"
          iconPosition="left"
          className="justify-start"
        >
          Emergency Access
        </Button>
        
        <Button
          variant="outline"
          onClick={handleComplianceReport}
          iconName="FileText"
          iconPosition="left"
          className="justify-start"
        >
          Compliance Report
        </Button>
        
        <Button
          variant="secondary"
          onClick={handleSecurityScan}
          iconName="Search"
          iconPosition="left"
          className="justify-start"
        >
          Security Scan
        </Button>
      </div>
    </div>
  );
};

export default QuickActions;